import type { ClinicalAuthor } from './clinical-author';

// Who anuló a registro clínico, when and why (ClinicalVoidSerializable): the
// person as the server froze them, never their RUT.
export type ClinicalVoidDetails = {
  humanVoidedAt: string;
  reason: string;
  by: ClinicalAuthor | null;
};

// What every registro clínico the office lists says about its anulación:
// whether it is anulado, the corrección it replaces, and whether the user may
// anular it now (its ventana de edición and their permissions).
export interface ClinicalVoidable {
  voided: boolean;
  voidDetails: ClinicalVoidDetails | null;
  correctsId: number | null;
  canVoid: boolean;
}

// The kind of corrección the office records with an anulación: a new text, a
// new value, or a new blood pressure. Without one the registro is only anulado.
export type ClinicalCorrectionKind = 'text' | 'value' | 'bloodPressure';

// "Anulado por Ana Pérez · Coordinadora · 21/10/2026 14:03 · Motivo: valor mal digitado"
export function clinicalVoidLine(details: ClinicalVoidDetails | null | undefined): string {
  if (!details) return '';

  const parts = [details.by?.label, details.humanVoidedAt, `Motivo: ${details.reason}`];

  return `Anulado por ${parts.filter(Boolean).join(' · ')}`;
}
